export const contactUs = {
  mailTo: 'us_gstar_support_team@pwc.com',
  subject: 'Support required in GSTAR with ...',
  body: 'We need support in GSTAR with [insert a description of your issue]\nPlease attach a screenshot',
};
